import {
    CONFIRMED_GET_PAYMENTS
} from '../actions/Payment/PaymentTypes';
const initialState = {
    payments: [],
    loading: false,
};

function PaymentReducer(state = initialState, actions) {
    switch (actions.type) {
        case 'PAYMENTS_LOADING':
            return {
                ...state,
                loading: true,
            };
        case 'PAYMENTS_LOADED':
            return {
                ...state,
                loading: false,
            };
        case CONFIRMED_GET_PAYMENTS:
            return {
                ...state,
                payments: actions.payload,
                loading: false,
            };
        default:
            return state;
    }
}

export {PaymentReducer};